// import Axios from "axios";

// export const SelectDroits = (a, b, c, d) => {
//   return (dispatch) => {
//     Axios.get(
//       `https://www.24-crm.tn/webservice/api/Droits?coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=PSDOSSIER`
//     ).then((response) => {
//       return dispatch({ type: "Droits_SELECT", payload: response.data });
//     });
//   };
// };
// redux/actions/GetDroits.js

export const SelectDroits = (coddos, serveur, user, pwd, database) => async (dispatch) => {
  try {
    const res = await fetch(
      `https://www.24-crm.tn/webservice/api/Droits/GetDroits/?coddos=${coddos}&serveur=${serveur}&user=${user}&pwd=${pwd}&database=PSDOSSIER`
    );

    const data = await res.json();

    console.log("API RESULT =>", data); // ✅ debug

    dispatch({
      type: "GET_DROITS",
      payload: data,
    });
  } catch (error) {
    console.error("Erreur API droits :", error);
  }
};